import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'


@Injectable()
export class AddressService {

    private baseAddressUrl = "/Address";  // URL to web api
    private autoCompleteURL = '';
    private getAddressDetailsURL = '';


    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseAddressUrl = this.configService.appConfig.UrlBase + this.baseAddressUrl;

        this.autoCompleteURL = this.baseAddressUrl + '/AutoComplete';
        this.getAddressDetailsURL = this.baseAddressUrl + '/GetAddressDetails';
    }

    autoComplete(filter: filters.AddressAutoCompleteFilter): Observable<ent.MyAddress[]> {
        return this.httpClient.post<ent.MyAddress[]>(this.autoCompleteURL, filter);
    }

    getAddressDetails(filter: filters.GetAddressDetailsFilter): Observable<ent.MyAddress> {
        return this.httpClient.post<ent.MyAddress>(this.getAddressDetailsURL, filter);
    }
}
